import React from "react";
import { motion } from "framer-motion";

export default function TechnologiesSection() {
  const categories = [
    {
      title: "Frontend",
      items: [
        { name: "React", icon: "⚛️", color: "#61DAFB" },
        { name: "Next.js", icon: "▲", color: "#ffffff" },
        { name: "TypeScript", icon: "📘", color: "#3178C6" },
        { name: "Tailwind", icon: "🎨", color: "#38BDF8" },
      ],
    },
    {
      title: "Backend & APIs",
      items: [
        { name: "Node.js", icon: "🟢", color: "#339933" },
        { name: "NestJS", icon: "🐱", color: "#E0234E" },
        { name: "Python", icon: "🐍", color: "#3776AB" },
        { name: "Express", icon: "🚂", color: "#ffffff" },
        { name: "REST APIs", icon: "🔌", color: "#00d4ff" },
        { name: "gRPC", icon: "⚡", color: "#00ADD8" },
        { name: "tRPC", icon: "🔷", color: "#398CCB" },
      ],
    },
    {
      title: "Mobile & Games",
      items: [
        { name: "React Native", icon: "📱", color: "#61DAFB" },
        { name: "Flutter", icon: "🐦", color: "#02569B" },
        { name: "Unity", icon: "🎮", color: "#ffffff" },
      ],
    },
    {
      title: "Cloud & DevOps",
      items: [
        { name: "AWS", icon: "☁️", color: "#FF9900" },
        { name: "Docker", icon: "🐳", color: "#2496ED" },
        { name: "CI/CD", icon: "⚙️", color: "#00d4ff" },
      ],
    },
    {
      title: "Databases",
      items: [
        { name: "MongoDB", icon: "🍃", color: "#47A248" },
        { name: "PostgreSQL", icon: "🐘", color: "#4169E1" },
        { name: "MySQL", icon: "🗄️", color: "#4479A1" },
        { name: "Redis", icon: "⚡", color: "#DC382D" },
      ],
    },
  ];

  return (
    <section className="technologies" id="technologies">
      <h2>Our Tech Stack</h2>
      <p className="section-subtitle">
        Modern, proven technologies we use to build products that last
      </p>

      <div className="tech-categories">
        {categories.map((category, ci) => (
          <motion.div
            key={category.title}
            className="tech-category"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: ci * 0.1, duration: 0.5 }}
          >
            <h3 className="tech-category-title">{category.title}</h3>
            <div className="tech-grid">
              {category.items.map((tech, i) => (
                <motion.div
                  key={tech.name}
                  className="tech-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.06 }}
                  whileHover={{
                    scale: 1.1,
                    rotate: 5,
                    boxShadow: `0 10px 30px ${tech.color}40`,
                  }}
                >
                  <div className="tech-icon" style={{ fontSize: "3rem" }}>
                    {tech.icon}
                  </div>
                  <div className="tech-name">{tech.name}</div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
